import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { RESOURCES_REQUESTED } from './constants';
import { getResourcesAPI } from '../../api';
import { resourcesSucceeded, resourcesFailed } from './actions';
import { getUserPermissionsKeys } from './../auth/selectors';
import { RESOURCES_FAQ_VIEW } from './../auth/constants';
import { parseClientError } from '../../api/utils';
import { logException } from '../../logger';

function* getResources() {
    try {
        const resources = yield call(getResourcesAPI);
        let userPermissions = yield select(getUserPermissionsKeys);

        let data = [];
        resources.data.forEach((element) => {
            if (userPermissions.includes(RESOURCES_FAQ_VIEW)) {
                data.push(element);
            } else if (element.key !== 'faq') {
                data.push(element);
            }
        });

        yield put(resourcesSucceeded({ data }));
    } catch (e) {
        Sentry.captureException(e);
        logException(e);
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(resourcesFailed(message));
    }
}

export default function*() {
    yield all([yield takeLatest(RESOURCES_REQUESTED, getResources)]);
}
